import PropTypes from 'prop-types';
import './CheckboxGroup.css';

/**
 * Reusable CheckboxGroup for multi-select arrays (certifications, growing practices)
 */
const CheckboxGroup = ({
  label,
  name,
  options = [],
  value = [],
  onChange,
  error,
  columns = 2,
  className = '',
}) => {
  const handleToggle = (optionValue) => {
    const newValue = value.includes(optionValue)
      ? value.filter((v) => v !== optionValue)
      : [...value, optionValue];
    onChange(name, newValue);
  };

  return (
    <fieldset className={`checkbox-group ${className}`}>
      {label && <legend className="checkbox-group__legend">{label}</legend>}
      <div
        className="checkbox-group__grid"
        style={{ '--cbg-columns': columns }}
      >
        {options.map((option) => {
          const checked = value.includes(option.value);
          return (
            <label
              key={option.value}
              className={`checkbox-group__item ${checked ? 'checkbox-group__item--checked' : ''}`}
            >
              <input
                type="checkbox"
                name={name}
                value={option.value}
                checked={checked}
                onChange={() => handleToggle(option.value)}
                className="checkbox-group__input"
              />
              <span className="checkbox-group__box" aria-hidden="true">
                {checked && (
                  <svg viewBox="0 0 12 12" className="checkbox-group__check">
                    <path d="M2.5 6L5 8.5L9.5 3.5" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
              </span>
              <span className="checkbox-group__label">{option.label}</span>
            </label>
          );
        })}
      </div>
      {error && <div className="checkbox-group__error">{error}</div>}
    </fieldset>
  );
};

CheckboxGroup.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  columns: PropTypes.number,
  className: PropTypes.string,
};

export default CheckboxGroup;
